import Button from "@/components/Button/index";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";

const EtrIssuanceTnCModal = ({ visible, hide, handleSubmit }) => {
	return (
		<Modal visible={visible} close={hide} dismissClickOutsideModal={false}>
			<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>Terms and Conditions</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div>
					<div className="etr-issuance-modal__content">
						<h2>
							Terms and Conditions of Access to the Common
							Data Infrastructure Prototype.
						</h2>
						<br />
						<p>
							These terms and conditions apply to your
							access and use of the Common Data
							Infrastructure (“CDI”) prototype - please
							read them carefully. By clicking Accept
							where indicated, you agree to accept these
							terms and conditions without modification.
							If you do not accept them, you may not use
							the CDI prototype.
						</p>
						<br />
						<p>
							Pursuant to the Alliances for Action, which
							was formed to provide solutions for the
							digitalisation of supply chains in Singapore
							under the Singapore’s Ministry of Trade and
							Industry’s Emerging Stronger Taskforce, PSA
							I-Tech Pte. Ltd. has engaged
							PricewaterhouseCoopers Risk Services Pte.
							Ltd. (“PwC” or “We” or “Us”) to design,
							build and test a working prototype for the
							CDI. In connection with this, you have
							agreed to participate in the assessment of
							the CDI prototype by integrating your
							systems into the CDI prototype and allowing
							certain information to be exchanged between
							you, us and other prototype participants
							(each, including you, a “Prototype
							Participant”) (“Purpose”).{" "}
						</p>
						<br />
						<p>
							In connection with the Purpose, you agree as
							follows:{" "}
						</p>
						<br />
						<p>
							1. You will only disclose or provide the
							following types of information to us for
							upload into the CDI prototype:{" "}
						</p>
						<br />
						<p>
							Historical production data; Data which is
							not Personal Data or Customer Information,
							where “Personal Data” shall have the meaning
							as defined under applicable data privacy
							laws including the Personal Data Protection
							Act (Act 26 of 2012 of Singapore) (“PDPA”)
							and “Customer Information” shall have the
							meaning as defined in the Banking Act (Cap.
							19) (“BA”);
						</p>
						<br />
						<p>and/or Dummy data.</p>
						<br />
						<p>
							For the avoidance of doubt, Personal Data
							excludes data that is:
						</p>
						<br />
						<p>
							Anonymised, aggregated, de-identified and/or
							compiled on a generic basis which does not
							name or identify a specific individual or
							person, directly or indirectly; and{" "}
						</p>
						<br />
						<p>
							It is no longer possible to re-identify an
							individual from the information; taking into
							account all means likely reasonably to be
							used by the anyone else to re-identify an
							individual.{" "}
						</p>
						<br />
						<p>
							2. You warrant that you have the necessary
							authority to disclose or provide the
							information to us and consent to our
							collection, use, disclosure and transfer of
							all such information to the other Prototype
							Participants participating in the Purpose
							and any PwC Firms or relevant subcontractors
							(who may be located in other territories)
							involved in the Purpose. A PwC Firm refer to
							any entity or partnership within the
							worldwide network of PricewaterhouseCoopers
							firms and entities, each of which is a
							separate and independent legal entity.
						</p>
						<br />
						<p>
							3. In respect of any information disclosed
							or made available to you in connection with
							the Purpose, you agree to:
						</p>
						<br />
						<p>
							Keep such information strictly confidential
							and use it only in connection with the
							Purpose;
						</p>
						<br />
						<p>
							Employ reasonable measures to protect such
							information as you would protect your own
							confidential information, provided that in
							no event shall this be less than a
							reasonable degree of care;
						</p>
						<br />
						<p>
							Not disclose such information to any third
							party without the prior written consent of
							the applicable disclosing party, except
							where required by law or regulation to do
							so; and
						</p>
						<br />
						<p>
							Upon conclusion of the Purpose, permanently
							destroy all such information in your
							possession or control (including permanently
							deleting such information from all computer
							records).{" "}
						</p>
						<br />
						<p>
							4. In consideration of our reliance on the
							contents of these terms and conditions, in
							the event any information other than the
							information referred to in paragraph 2 above
							is disclosed or provided by you to us, you
							will be solely responsible and liable for
							any breach of any applicable laws including
							the PDPA and the BA and agree to indemnify
							us from any and all liabilities incurred by
							us including all claims and all direct,
							indirect or consequential liabilities,
							proceedings, damages, costs and expenses
							(including legal costs), awarded against, or
							incurred or paid by, us as a result of or in
							connection with the use or processing of the
							information or any breach of any applicable
							laws including the PDPA and BA.
						</p>
						<br />
						<p>
							5. Hosting: You understand that the CDI
							prototype will be hosted by PwC’s
							subcontractor on Amazon Web Services (“AWS”)
							servers located in Singapore and may
							include, as applicable, use of certain of
							the services and features identified at
							https://aws.amazon.com/ (all of the
							foregoing, collectively, “AWS Services”).
						</p>
						<br />
						<p>
							Your use and participation in the assessment
							of the CDI prototype is subject to
							compliance with the AWS Acceptable Use
							Policy ( https://aws.amazon.com/aup), the
							terms and conditions imposed by AWS
							regarding access to and use of the AWS
							Services (such terms and conditions as they
							may be updated, amended or modified from
							time to time by AWS, the “AWS Terms”), and
							any applicable law. The AWS Terms include
							the product use rights (and the terms of the
							acceptable use policy, which is described
							therein) which is substantially in the form
							of the AWS Service Terms available at
							https://aws.amazon.com/service-terms. You
							are solely responsible for (i) complying
							with the AWS Terms at all times in
							connection accessing and using the CDI
							Prototype; and (ii) ensuring that any
							information that you provide to us, or that
							you input, transmit or upload to, or
							otherwise process on or through, the CDI
							prototype in connection with the Purpose
							(“Your Content”) complies with AWS Terms.
						</p>
						<br />
						<p>
							You will defend, indemnify, and hold
							harmless PwC, its subcontractors,
							affiliates, licensors, and each of their
							respective employees, officers, directors,
							and representatives from and against any
							losses arising out of or relating to any
							third- party claim that arises from (i) a
							violation of the AWS Terms, Acceptable Use
							Policy by you, or (ii) any dispute between
							you and any other Prototype Participants.
						</p>
						<br />
						<p>
							You will defend, indemnify, and hold
							harmless PwC, its subcontractors,
							affiliates, and their respective employees,
							officers, and directors against any
							third-party claim alleging that any of Your
							Content infringes or misappropriates that
							third party’s intellectual property rights,
							and will pay the amount of any adverse final
							judgment or settlement.
						</p>
						<br />
						<p>
							We may terminate your participation in the
							Purpose immediately by giving written notice
							if you breach, or cause us to breach, any
							applicable terms and conditions of AWS.
						</p>
						<br />
						<p>
							6. The CDI prototype may contain certain
							open source software components. To the
							extent that the CDI prototype contains open
							source software, notwithstanding anything
							else to the contrary here or elsewhere, you
							acknowledge and agree that your use of such
							open source software is governed by the
							applicable open source license terms and
							that, subject to applicable law, PwC has no
							obligation or liability with respect to such
							open source software. You acknowledge that
							any open source software contained in the
							CDI prototype is provided on an “as is”
							basis only.
						</p>
						<br />
						<p>
							7.The CDI prototype is provided to you on an
							as is basis for testing purposes only and
							any use of CDI prototype shall be at your
							own risk. To the maximum extent permitted by
							applicable law, PwC disclaims all warranties
							with respect to the CDI prototype, express,
							implied and statutory, including without
							limitation any implied warranties of
							merchantability, fitness for a particular
							purpose, accuracy, completeness, non-
							infringement, timeliness, non-interference,
							error-free service and uninterrupted
							service. You further agree and understand
							that information and data uploaded on the
							CDI prototype may be irretrievably lost or
							destroyed at any time. You agree that PwC
							will not have any liability due to your
							inability to access the CDI prototype, any
							portion thereof or any data or information
							uploaded on the CDI prototype, nor will PwC
							have any liability in connection with the
							loss or destruction of any data or
							information uploaded on the CDI prototype.
						</p>
						<br />
						<p>
							These terms and conditions are governed by
							the laws of Singapore and is subject to the
							exclusive jurisdiction of the Singapore
							courts.
						</p>
					</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<div className="tnc-modal__confirmation_actions">
						<Button
							data-testid="etr-issuance-tnc-decline"
							ghost
							round
							addClass="eap-modal__transButton"
							submit={() => hide()}
							text="Decline"
						/>
						<Button
							data-testid="etr-issuance-tnc-agree"
							full
							round
							submit={() => handleSubmit()}
							text="Agree & Submit"
						/>
					</div>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

export default EtrIssuanceTnCModal;
